import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

function SvgEntretientSuiviIcon(props) {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={27} height={27} fill="none" viewBox="0 0 27 27" {...props}>
            <G clipPath="url(#clip0)">
                <Path
                    fill="#FFE177"
                    d="M18 8v7.928C18 17.072 17.212 18 16.24 18H9v-1.428h6.027c.972 0 1.76-.928 1.76-2.072V8H18z"
                />
                <Path
                    fill={baseColors.orange.primary}
                    d="M27 9.864v9.753c0 1.03-.693 1.8-1.619 1.8l-.835.063h-.787c-.155 0-.28.14-.28.312v2.896c0 .267-.282.41-.463.236l-3.498-3.367a.264.264 0 00-.183-.076h-8.659C9.752 21.48 9 20.645 9 19.616V16.99l.577-.778L9 15.707V9.864C9 8.834 9.75 8 10.677 8h5.682l.464.642.749-.642h6.086l1.723.064c.926 0 1.619.77 1.619 1.8z"
                />
                <Path
                    fill={baseColors.green.primary}
                    d="M0 5.864v9.753c0 1.03.75 1.863 1.677 1.863h1.622c.155 0 .28.14.28.312v2.896c0 .267.282.41.463.236l3.498-3.368a.264.264 0 01.183-.076h6.992l.908-.064c.926 0 1.363-.77 1.363-1.799L18 5.864c0-1.03-.693-1.8-1.619-1.8L14.725 4H1.677C.75 4 0 4.834 0 5.864z"
                />
                <Path
                    fill="#fff"
                    d="M24.79 11.947h-5.335c-.238 0-.432-.212-.432-.473 0-.262.194-.474.432-.474h5.335c.239 0 .432.212.432.473 0 .262-.194.474-.432.474zm0 3.528h-5.335c-.238 0-.432-.212-.432-.473 0-.262.194-.474.432-.474h5.335c.239 0 .432.212.432.474 0 .261-.194.473-.432.473zm0 3.527H12.432c-.239 0-.432-.212-.432-.474 0-.261.193-.473.432-.473H24.79c.239 0 .432.212.432.473 0 .262-.193.474-.432.474z"
                />
                <Path
                    fill="#EEF5F6"
                    d="M9.029 14.41c.242 0 .438-.214.438-.48 0-.265-.196-.48-.438-.48s-.438.215-.438.48c0 .266.196.48.438.48zM9.029 12.493c-.24 0-.433-.213-.433-.475v-1.869c0-.262.194-.475.433-.475.331 0 .64-.145.868-.409.228-.264.344-.61.327-.974-.032-.682-.546-1.227-1.17-1.241-.606-.013-1.127.472-1.21 1.128a1.46 1.46 0 00-.012.184c0 .262-.194.475-.433.475s-.433-.213-.433-.475c0-.105.007-.211.02-.315C7.13 6.914 8.028 6.077 9.07 6.1c1.076.024 1.962.965 2.018 2.142.03.627-.17 1.223-.564 1.677-.287.332-.66.558-1.063.654v1.445c0 .262-.194.475-.433.475z"
                />
                <Path
                    fill={baseColors.green.pastel}
                    d="M18 5.858v9.728c0 1.027-.914 1.894-2 1.894h-2c1.086 0 1.967-.867 1.967-1.894V5.858C15.967 4.832 15.087 4 14 4h2.033C17.119 4 18 4.832 18 5.858z"
                />
            </G>
            <Defs>
                <ClipPath id="clip0">
                    <Path fill="#fff" d="M0 0h27v27H0z" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default SvgEntretientSuiviIcon
